import React, { forwardRef, useState } from 'react'
import moment from "moment-mini";
import handleNumericCheck from 'Utils/NumericCheck';
import CustomLabel from 'Common/CustomLabel/CustomLabel';
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import { Eye, EyeOff } from 'lucide-react';

const CustomInput = forwardRef(({
    wrapperClass,
    label,
    labelClass,
    className = "",
    required,
    type,
    name,
    value,
    onChange,
    isNumeric,
    isFloat,
    maxFloat,
    maxLength,
    allowNegative,
    onKeyPress,
    toLower,
    UpperCase,
    id,
    prefixIcon,
    Icon,
    suffixIcon,
    iconClass,
    toolTip,
    ...inputProps }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className={`flex flex-col gap-2 w-full ${wrapperClass}`}>
            {label && <CustomLabel iconClass={iconClass} Icon={Icon} toolTip={toolTip} htmlFor={id} label={label} labelClass={labelClass} required={required} />}
            <div className='relative'>
                {prefixIcon && <span className='absolute -translate-y-1/2 left-1 top-1/2'>{prefixIcon}</span>}
                {suffixIcon && <span className='absolute -translate-y-1/2 right-1 top-1/2'>{suffixIcon}</span>}
                <input
                    {...inputProps}
                    ref={ref}
                    value={value || ""}
                    maxLength={maxLength}
                    type={showPassword ? "text" : type}
                    autoComplete="off"
                    onPaste={
                        type === "date"
                            ? (e) => {
                                const pastedDate = e.clipboardData.getData("text/plain");
                                let trimeddate = pastedDate.trim();
                                const formattedDate = moment(trimeddate).format("YYYY-MM-DD");
                                onChange({ target: { value: formattedDate, name: name } });
                            }
                            : (e) => {
                                const pastedValue = e.clipboardData.getData("text/plain");
                                let trimmedValue = pastedValue.trim();
                                if (isNumeric) {
                                    const regex = new RegExp(`^-?\\d*\\.?\\d*$`);

                                    if (
                                        regex.test(trimmedValue) ||
                                        trimmedValue === "-" ||
                                        trimmedValue === ""
                                    ) {
                                        onChange({
                                            target: {
                                                value: trimmedValue,
                                                name: name,
                                                dataset: e.target.dataset,
                                            },
                                        });
                                        e.preventDefault();
                                        return true;
                                    } else {
                                        e.preventDefault();
                                        return false;
                                    }
                                } else {
                                    const cursorPosition = e.target.selectionStart;
                                    const currentValue = e.target.value;
                                    const textToInsert = trimmedValue;

                                    if (cursorPosition !== null && cursorPosition !== undefined) {
                                        const beforeCursor = currentValue.slice(0, cursorPosition);
                                        const afterCursor = currentValue.slice(cursorPosition);
                                        const newValue = beforeCursor + textToInsert + afterCursor;
                                        onChange({
                                            target: {
                                                value: newValue,
                                                name: name,
                                                dataset: e.target.dataset,
                                            },
                                        });
                                    } else {
                                        onChange({
                                            target: {
                                                value: currentValue + textToInsert,
                                                name: name,
                                                dataset: e.target.dataset,
                                            },
                                        });
                                    }
                                    e.preventDefault();
                                }
                            }
                    }
                    onKeyPress={
                        isNumeric
                            ? (e) => {
                                handleNumericCheck(
                                    e,
                                    isFloat ? "allowFloat" : "",
                                    maxFloat,
                                    allowNegative,
                                    maxLength
                                );

                                if (onKeyPress) {
                                    onKeyPress(e);
                                }
                            }
                            : onKeyPress
                                ? onKeyPress
                                : () => { }
                    }
                    // (e) => {
                    // let p = e.target.selectionStart;
                    // e.target.value = e.target.value.toUpperCase();
                    // e.target.setSelectionRange(p, p);
                    // }
                    onInput={
                        type === "date"
                            ? () => { }
                            : toLower
                                ? (e) => (e.target.value = "" + e.target.value)
                                : type !== "number" && type !== "email"
                                    ? UpperCase
                                    : (e) => (e.target.value = "" + e.target.value)
                    }
                    {...inputProps}
                    name={name}
                    onChange={(e) => {
                        const raw = e.target?.value ?? '';
                        const trimmedStart = type === 'date' ? raw : raw.trimStart();
                        if (trimmedStart !== raw) {
                            e = { ...e, target: { ...e.target, value: trimmedStart, name } };
                        }
                        onChange(e);
                    }}
                    className={`customInputClass h-9 ${prefixIcon && "pl-6"} ${suffixIcon && "pr-6"} ${className}`}
                    id={id}
                />

                {type === "password" && (
                    <button className='text-gray-500' onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? (
                            <Eye
                                size={18}
                                className="absolute right-1 top-1/2 -translate-x-1/2 -translate-y-1/2"
                            />
                        ) : (
                            <EyeOff
                                size={18}
                                className="absolute right-1 top-1/2 -translate-x-1/2 -translate-y-1/2"
                            />
                        )}                    </button>
                )}
            </div>
        </div>
    )
})

export default withFeatureSafe(CustomInput)